import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const filterChipStyles = tv({
    slots: {
        base: `
      iris:group
      iris:cursor-pointer
      iris:overflow-hidden
      iris:rounded-(--comp-size-radius-chip-filter)
      iris:border-(length:--comp-size-border-chip-filter)
      iris:border-transparent
      iris:font-(family-name:--comp-type-font-chip-filter)
      iris:text-(length:--comp-type-size-chip-filter)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-chip-filter)!
      iris:tracking-(--comp-type-tracking-chip-filter)
      iris:duration-(--comp-motion-duration-chip-filter)
      iris:ease-(--comp-motion-easing-chip-filter)
    `,
        wrapper: `
      iris:inline-flex
      iris:h-(--comp-size-height-chip-filter)
      iris:min-h-(--base-space-px-32)
      iris:w-full
      iris:min-w-(--base-space-px-32)
      iris:items-center
      iris:py-(--comp-space-padding-chip-filter-vertical)
      iris:transition-all
      iris:duration-(--comp-motion-duration-chip-filter)
      iris:ease-(--comp-motion-easing-chip-filter)
    `,
        quantity: "",
        icon: "iris:size-(--base-space-px-16)",
    },
    variants: {
        selected: {
            true: {
                wrapper: `
          iris:gap-(--comp-space-gap-chip-filter-icon)
          iris:pr-(--comp-space-padding-chip-filter-selected-right)
          iris:pl-(--comp-space-padding-chip-filter-selected-left)
        `,
                quantity: "",
            },
            false: {
                wrapper: `
          iris:gap-(--comp-space-gap-chip-filter-text)
          iris:px-(--comp-space-padding-chip-filter-horizontal)
        `,
                quantity: "",
            },
        },
        inverse: {
            true: {
                base: focusStyles.inverse,
                quantity: "iris:text-(--comp-color-content-chip-filter-count-text-inverse)",
                icon: "iris:text-(--comp-color-content-chip-filter-icon-inverse)",
            },
            false: {
                base: focusStyles.default,
                quantity: "iris:text-(--comp-color-content-chip-filter-count-text)",
                icon: "iris:text-(--comp-color-content-chip-filter-icon)",
            },
        },
        disabled: {
            true: {},
            false: {},
        },
    },
    compoundVariants: [
        {
            selected: false,
            inverse: false,
            class: {
                base: `
          iris:border-(length:--comp-size-border-chip-filter)
          iris:border-(--comp-color-border-chip-filter-rest)
          iris:bg-(--comp-color-background-chip-filter-rest)
          iris:hover:border-(--comp-color-border-chip-filter-hover)
          iris:active:border-(--comp-color-border-chip-filter-pressed)
        `,
                wrapper: `
          iris:bg-(--comp-color-background-chip-filter-rest)
          iris:text-(--comp-color-content-chip-filter-label-rest)
          iris:group-hover:bg-(--comp-color-background-chip-filter-hover)
          iris:group-hover:text-(--comp-color-content-chip-filter-label-hover)
          iris:group-active:bg-(--comp-color-background-chip-filter-pressed)
          iris:group-active:text-(--comp-color-content-chip-filter-label-pressed)
        `,
            },
        },
        {
            selected: false,
            inverse: true,
            class: {
                base: `
          iris:border-(length:--comp-size-border-chip-filter)
          iris:border-(--comp-color-border-chip-filter-inverse-rest)
          iris:hover:border-(--comp-color-border-chip-filter-inverse-hover)
          iris:active:border-(--comp-color-border-chip-filter-inverse-pressed)
        `,
                wrapper: `
          iris:bg-(--comp-color-background-chip-filter-inverse-rest)
          iris:text-(--comp-color-content-chip-filter-label-inverse-rest)
          iris:group-hover:bg-(--comp-color-background-chip-filter-inverse-hover)
          iris:group-hover:text-(--comp-color-content-chip-filter-label-inverse-hover)
          iris:group-active:bg-(--comp-color-background-chip-filter-inverse-pressed)
          iris:group-active:text-(--comp-color-content-chip-filter-label-inverse-pressed)
        `,
            },
        },
        {
            selected: true,
            inverse: false,
            class: {
                base: "",
                wrapper: `
          iris:bg-(--comp-color-background-chip-filter-selected-rest)
          iris:text-(--comp-color-content-chip-filter-label-selected-rest)
          iris:group-hover:bg-(--comp-color-background-chip-filter-selected-hover)
          iris:group-hover:text-(--comp-color-content-chip-filter-label-selected-hover)
          iris:group-active:bg-(--comp-color-background-chip-filter-selected-pressed)
          iris:group-active:text-(--comp-color-content-chip-filter-label-selected-pressed)
        `,
                icon: "iris:text-(--comp-color-content-chip-filter-icon)",
            },
        },
        {
            selected: true,
            inverse: true,
            class: {
                wrapper: `
          iris:bg-(--comp-color-background-chip-filter-selected-inverse-rest)
          iris:text-(--comp-color-content-chip-filter-label-selected-inverse-rest)
          iris:group-hover:bg-(--comp-color-background-chip-filter-selected-inverse-hover)
          iris:group-hover:text-(--comp-color-content-chip-filter-label-selected-inverse-hover)
          iris:group-active:bg-(--comp-color-background-chip-filter-selected-inverse-pressed)
          iris:group-active:text-(--comp-color-content-chip-filter-label-selected-inverse-pressed)
        `,
                icon: "iris:text-(--comp-color-content-chip-filter-icon-inverse)",
            },
        },
        {
            selected: false,
            disabled: true,
            class: {
                base: `
          iris:pointer-events-none
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
            },
        },
        {
            selected: false,
            inverse: false,
            disabled: true,
            class: {
                base: `
          iris:border-(--comp-color-border-chip-filter-rest)
          iris:bg-(--comp-color-background-chip-filter-rest)
        `,
                wrapper: "iris:text-(--comp-color-content-chip-filter-label-rest)",
            },
        },
        {
            selected: false,
            inverse: true,
            disabled: true,
            class: {
                base: `
          iris:border-(--comp-color-border-chip-filter-inverse-rest)
          iris:bg-(--comp-color-background-chip-filter-inverse-rest)
        `,
                wrapper: "iris:text-(--comp-color-content-chip-filter-label-inverse-rest)",
            },
        },
    ],
    defaultVariants: {
        selected: false,
        inverse: false,
        disabled: false,
    },
});

export { filterChipStyles as default };
